import { Suspense, lazy } from 'react';
import { Route, Navigate } from 'react-router';
import { routePathsAdmin } from 'core/lib/routePaths/adminRoutePaths';
import { RouteLoader } from '#components/Loader/RouteLoader';

const Admin = lazy(() => import('admin/central-routes/admin-routes'));

const UsersRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.UsersRoute,
  })),
);

const InviteUserRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.InviteUserRoute,
  })),
);

const UserDetailRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.UserDetailRoute,
  })),
);

const AddLocationRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.AddLocationRoute,
  })),
);

const LocationsRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.LocationsRoute,
  })),
);

const RequestNewLocationRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.RequestNewLocationRoute,
  })),
);

const RequestNewLocationConfirmationRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.RequestNewLocationConfirmationRoute,
  })),
);

const LocationDetailRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.LocationDetailRoute,
  })),
);

const SubscriptionsRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.SubscriptionsRoute,
  })),
);

const ProfileRoute = lazy(() =>
  import('admin/central-routes/admin-routes').then((module) => ({
    default: module.ProfileRoute,
  })),
);

export const AdminRouteTree = (
  <Route
    path={routePathsAdmin.HOME}
    element={
      <Suspense fallback={<RouteLoader />}>
        <Admin />
      </Suspense>
    }
  >
    <Route
      index
      path={routePathsAdmin.HOME}
      element={<Navigate to={routePathsAdmin.USERS} replace={true} />}
    />
    <Route path={routePathsAdmin.USERS}>
      <Route index element={<UsersRoute />} />
      <Route path={routePathsAdmin.INVITE} element={<InviteUserRoute />} />
      <Route path={routePathsAdmin.ADD_LOCATION} element={<AddLocationRoute />} />
      <Route path={routePathsAdmin.USER_DETAILS} element={<UserDetailRoute />} />
    </Route>
    <Route path={routePathsAdmin.LOCATIONS}>
      <Route index element={<LocationsRoute />} />
      <Route path={routePathsAdmin.REQUEST_NEW_LOCATION}>
        <Route index element={<RequestNewLocationRoute />} />
        <Route
          path={routePathsAdmin.REQUEST_NEW_LOCATION_CONFIRMATION}
          element={<RequestNewLocationConfirmationRoute />}
        />
      </Route>
      <Route path={routePathsAdmin.REQUEST_NEW_LOCATION}>
        <Route index element={<RequestNewLocationRoute />} />
        <Route
          path={routePathsAdmin.REQUEST_NEW_LOCATION_CONFIRMATION}
          element={<RequestNewLocationConfirmationRoute />}
        />
      </Route>
      <Route path={routePathsAdmin.LOCATION_DETAILS} element={<LocationDetailRoute />} />
    </Route>
    <Route path={routePathsAdmin.SUBSCRIPTIONS} element={<SubscriptionsRoute />} />
    <Route path={routePathsAdmin.PROFILE}>
      <Route index element={<Navigate to={'details'} replace={true} />} />
      <Route path={routePathsAdmin.PROFILE_SUBS} element={<ProfileRoute />} />
    </Route>
  </Route>
);

export const preloadAdmin = () => {
  //Import default export to trigger preload
  void import('admin/central-routes/admin-routes');
};
